/* =====================================================================
   CyberDress 2026 — Bdress
   Vanilla JS modules. Auto-initialises against [data-cyberdress-root].
   Safe to load multiple times; each module no-ops if its targets are absent.
   ===================================================================== */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function formatCLP(n) {
    return '$' + Math.round(n).toLocaleString('es-CL');
  }
  function pad(n) { return String(n).padStart(2, '0'); }

  // Shared state across modules in this page load.
  var cdState = window.__cyberdress = window.__cyberdress || { recommendation: null };

  // ---------- 1. EDITION STRIP STICKY ----------
  function initEditionStrip() {
    var strip = document.querySelector('[data-cyberdress-edition-strip]');
    var grid = document.querySelector('[data-cyberdress-collection]');
    var finale = document.querySelector('[data-cyberdress-finale]');
    if (!strip || !grid) return;

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var gridTop = grid.getBoundingClientRect().top;
        var finaleTop = finale ? finale.getBoundingClientRect().top : Infinity;
        if (gridTop < 60 && finaleTop > window.innerHeight) {
          strip.classList.add('cyberdress-edition-strip--sticky');
        } else {
          strip.classList.remove('cyberdress-edition-strip--sticky');
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ---------- 2. COUNTDOWN ----------
  function initCountdown() {
    var countdown = document.querySelector('[data-cyberdress-countdown]');
    if (!countdown) return;
    var endRaw = countdown.getAttribute('data-end-date');
    if (!endRaw) return;
    var endDate = new Date(endRaw).getTime();
    if (isNaN(endDate)) return;

    var els = {
      days: countdown.querySelector('[data-unit="days"]'),
      hours: countdown.querySelector('[data-unit="hours"]'),
      minutes: countdown.querySelector('[data-unit="minutes"]'),
      seconds: countdown.querySelector('[data-unit="seconds"]')
    };
    var urgencyEl = document.querySelector('[data-cyberdress-urgency-time]');
    var endedLabel = countdown.getAttribute('data-ended-label') || 'Edición cerrada';

    function tick() {
      var diff = endDate - Date.now();
      if (diff <= 0) {
        countdown.innerHTML = '<p class="cyberdress-hero__countdown--ended">' + endedLabel + '</p>';
        if (urgencyEl) urgencyEl.textContent = 'YA';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (els.days) els.days.textContent = pad(d);
      if (els.hours) els.hours.textContent = pad(h);
      if (els.minutes) els.minutes.textContent = pad(m);
      if (els.seconds) els.seconds.textContent = pad(s);
      if (urgencyEl) {
        urgencyEl.textContent = d > 0 ? d + ' día' + (d > 1 ? 's' : '') : h + 'h ' + m + 'm';
      }
      window.setTimeout(tick, 1000);
    }
    tick();
  }

  // ---------- 3. LOOKBOOK TABS ----------
  function initLookbook() {
    var tabs = document.querySelectorAll('[data-cyberdress-lookbook-tab]');
    var panels = document.querySelectorAll('[data-cyberdress-lookbook-panel]');
    if (!tabs.length || !panels.length) return;

    function activate(target) {
      tabs.forEach(function (t) {
        var match = t.getAttribute('data-cyberdress-lookbook-tab') === target;
        t.classList.toggle('cyberdress-lookbook__tab--active', match);
        t.setAttribute('aria-selected', match ? 'true' : 'false');
        t.setAttribute('tabindex', match ? '0' : '-1');
      });
      panels.forEach(function (p) {
        var match = p.getAttribute('data-cyberdress-lookbook-panel') === target;
        p.classList.toggle('cyberdress-lookbook__panel--active', match);
        p.hidden = !match;
      });
    }

    tabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-cyberdress-lookbook-tab'));
      });
      tab.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var next = tabs[(idx + dir + tabs.length) % tabs.length];
        next.focus();
        activate(next.getAttribute('data-cyberdress-lookbook-tab'));
      });
    });
  }

  // ---------- 4. QUIZ ----------
  function initQuiz() {
    var quizRoot = document.querySelector('[data-cyberdress-quiz]');
    if (!quizRoot) return;
    var steps = quizRoot.querySelectorAll('[data-cyberdress-quiz-step]');
    var progressBar = quizRoot.querySelector('[data-cyberdress-quiz-progress]');
    var restart = quizRoot.querySelector('[data-cyberdress-quiz-restart]');
    if (!steps.length) return;

    var editionsData = readEditions();
    var resultsByKey = {};
    editionsData.forEach(function (ed) { resultsByKey[ed.slug] = ed; });

    function mapping(events, style) {
      if (events === '1' && style === 'simple') return 'essential';
      if (events === '1' && style === 'complete') return 'classic';
      if (events === '1' && style === 'premium') return 'premium';
      if (events === '2-3' && style === 'simple') return 'classic';
      if (events === '2-3' && style === 'complete') return 'premium';
      if (events === '2-3' && style === 'premium') return 'signature';
      if (events === '4+') return 'yearpass';
      return 'premium';
    }

    var answers = {};

    function showStep(n) {
      steps.forEach(function (s) {
        var match = s.getAttribute('data-cyberdress-quiz-step') === String(n);
        s.classList.toggle('cyberdress-quiz__step--active', match);
      });
      if (progressBar) progressBar.style.width = (n / 3 * 100) + '%';
    }

    quizRoot.querySelectorAll('[data-cyberdress-quiz-step="1"] [data-events]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        answers.events = btn.getAttribute('data-events');
        showStep(2);
      });
    });

    quizRoot.querySelectorAll('[data-cyberdress-quiz-step="2"] [data-style]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        answers.style = btn.getAttribute('data-style');
        var key = mapping(answers.events, answers.style);
        var result = resultsByKey[key] || resultsByKey.premium;
        if (!result) return;

        var titleEl = quizRoot.querySelector('[data-cyberdress-quiz-result-title]');
        var textEl = quizRoot.querySelector('[data-cyberdress-quiz-result-text]');
        var priceEl = quizRoot.querySelector('[data-cyberdress-quiz-result-price]');
        var receiveEl = quizRoot.querySelector('[data-cyberdress-quiz-result-receive]');
        var ctaEl = quizRoot.querySelector('[data-cyberdress-quiz-result-cta]');
        if (titleEl) titleEl.innerHTML = '<em>' + escapeHtml(result.name) + '</em>';
        if (textEl) textEl.textContent = result.reason || '';
        if (priceEl) priceEl.textContent = formatCLP(result.pays);
        if (receiveEl) receiveEl.textContent = formatCLP(result.receives);
        if (ctaEl && result.cta_url) ctaEl.setAttribute('href', result.cta_url);

        cdState.recommendation = {
          name: result.name,
          price: formatCLP(result.pays),
          receive: formatCLP(result.receives),
          text: result.reason || '',
          anchor: result.cta_url || ('#cyberdress-edition-' + result.slug)
        };
        showStep(3);
      });
    });

    if (restart) {
      restart.addEventListener('click', function () {
        answers = {};
        cdState.recommendation = null;
        showStep(1);
      });
    }
  }

  // ---------- 5. BUILD YOUR YEAR ----------
  function initByYear() {
    var byyear = document.querySelector('[data-cyberdress-byyear]');
    if (!byyear) return;
    var eventBtns = byyear.querySelectorAll('[data-cyberdress-event]');
    var empty = byyear.querySelector('[data-cyberdress-byyear-empty]');
    var filled = byyear.querySelector('[data-cyberdress-byyear-filled]');
    var totalEl = byyear.querySelector('[data-cyberdress-byyear-total]');
    var withEl = byyear.querySelector('[data-cyberdress-byyear-with]');
    var savingsEl = byyear.querySelector('[data-cyberdress-byyear-savings]');
    var nameEl = byyear.querySelector('[data-cyberdress-byyear-name]');
    var reasonEl = byyear.querySelector('[data-cyberdress-byyear-reason]');
    var ctaEl = byyear.querySelector('[data-cyberdress-byyear-cta]');
    var resetBtn = byyear.querySelector('[data-cyberdress-byyear-reset]');
    if (!eventBtns.length) return;

    var editions = readEditions();
    if (!editions.length) return;
    var sorted = editions.slice().sort(function (a, b) { return a.pays - b.pays; });

    var counts = {};

    function calculate() {
      var totalEvents = 0;
      var totalCost = 0;
      eventBtns.forEach(function (btn) {
        var key = btn.getAttribute('data-cyberdress-event');
        var cost = parseInt(btn.getAttribute('data-cost'), 10) || 0;
        var c = counts[key] || 0;
        totalEvents += c;
        totalCost += c * cost;
      });

      if (totalEvents === 0) {
        if (filled) filled.hidden = true;
        if (empty) empty.hidden = false;
        if (resetBtn) resetBtn.hidden = true;
        return;
      }

      if (empty) empty.hidden = true;
      if (filled) filled.hidden = false;
      if (resetBtn) resetBtn.hidden = false;

      var best = sorted[0];
      for (var i = 0; i < sorted.length; i++) {
        if (sorted[i].receives >= totalCost) { best = sorted[i]; break; }
        best = sorted[i];
      }
      // If total exceeds the biggest edition's value, recommend the biggest.
      var biggest = sorted[sorted.length - 1];
      if (totalCost >= biggest.receives) best = biggest;

      var savings = totalCost - best.pays;
      var finalSavings = savings > 0 ? savings : (best.receives - best.pays);

      if (totalEl) totalEl.textContent = formatCLP(totalCost);
      if (withEl) withEl.textContent = formatCLP(best.pays);
      if (savingsEl) savingsEl.textContent = formatCLP(finalSavings);
      if (nameEl) nameEl.innerHTML = '<em>' + escapeHtml(best.name) + '</em>';
      if (reasonEl) reasonEl.textContent = best.reason || '';
      if (ctaEl && best.cta_url) ctaEl.setAttribute('href', best.cta_url);

      cdState.recommendation = {
        name: best.name,
        price: formatCLP(best.pays),
        receive: formatCLP(best.receives),
        text: best.reason || '',
        anchor: best.cta_url || ('#cyberdress-edition-' + best.slug)
      };
    }

    eventBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-cyberdress-event');
        var next = (counts[key] || 0) + 1;
        if (next > 9) next = 0;
        counts[key] = next;
        btn.classList.toggle('cyberdress-byyear__event--active', next > 0);
        var counter = btn.querySelector('[data-cyberdress-event-counter]');
        if (counter) counter.textContent = next;
        calculate();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        eventBtns.forEach(function (btn) {
          var key = btn.getAttribute('data-cyberdress-event');
          counts[key] = 0;
          btn.classList.remove('cyberdress-byyear__event--active');
          var counter = btn.querySelector('[data-cyberdress-event-counter]');
          if (counter) counter.textContent = '0';
        });
        calculate();
      });
    }
  }

  // ---------- 6. EXIT MODAL ----------
  function initExitModal() {
    var modal = document.querySelector('[data-cyberdress-exit-modal]');
    if (!modal) return;
    // The form is rendered by Shopify's {% form 'customer' %} tag, so we
    // grab it by id instead of a data attribute.
    var form = modal.querySelector('#cyberdress-exit-form');
    var title = modal.querySelector('[data-cyberdress-exit-title]');
    var sub = modal.querySelector('[data-cyberdress-exit-sub]');
    var selection = modal.querySelector('[data-cyberdress-exit-selection]');
    var selectionName = modal.querySelector('[data-cyberdress-exit-selection-name]');
    var selectionPrice = modal.querySelector('[data-cyberdress-exit-selection-price]');
    var submitBtn = modal.querySelector('[data-cyberdress-exit-submit]');
    var emailInput = modal.querySelector('[data-cyberdress-exit-email]');
    var tagsInput = modal.querySelector('[data-cyberdress-exit-tags]');
    var noteInput = modal.querySelector('[data-cyberdress-exit-note]');
    var defaultTags = tagsInput ? tagsInput.value : '';
    var shown = false;
    var timeOnPage = 0;

    function buildContent() {
      var rec = cdState.recommendation;
      if (rec) {
        if (title) title.textContent = 'Te guardamos tu ' + rec.name;
        if (sub) sub.innerHTML = 'Te enviamos al email el link directo a tu edición <strong>' + escapeHtml(rec.name) + '</strong> para que la termines de comprar antes que cierre la edición CyberDress.';
        if (selectionName) selectionName.textContent = rec.name;
        if (selectionPrice) selectionPrice.textContent = rec.price + ' · recibes ' + rec.receive;
        if (selection) selection.hidden = false;
        if (submitBtn) submitBtn.textContent = 'Guardarme la ' + rec.name + ' →';
      } else {
        if (title) title.textContent = '¿Te llevamos esto en mente?';
        if (sub) sub.innerHTML = 'Te enviamos tu selección al email con un <strong>link directo al checkout</strong>. Termina de comprar cuando estés lista — siempre que vuelvas antes que cierre la edición.';
        if (selection) selection.hidden = true;
        if (submitBtn) submitBtn.textContent = 'Guardar mi selección →';
      }
    }

    function open() {
      if (shown) return;
      shown = true;
      buildContent();
      modal.classList.add('cyberdress-exit-modal--visible');
      modal.setAttribute('aria-hidden', 'false');
      if (emailInput) {
        window.setTimeout(function () { try { emailInput.focus(); } catch (e) {} }, 200);
      }
    }
    function close() {
      modal.classList.remove('cyberdress-exit-modal--visible');
      modal.setAttribute('aria-hidden', 'true');
    }

    document.addEventListener('mouseleave', function (e) {
      if (e.clientY < 0 && timeOnPage > 15) open();
    });
    window.setInterval(function () {
      timeOnPage += 1;
      if (timeOnPage === 45 && window.innerWidth < 900) open();
    }, 1000);

    modal.querySelectorAll('[data-cyberdress-exit-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('cyberdress-exit-modal--visible')) close();
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var rec = cdState.recommendation;

        // Enrich hidden fields with the quiz/calculator recommendation,
        // so Shopify Email can segment by tag and the team sees context.
        if (tagsInput) {
          var tags = defaultTags;
          if (rec && rec.name) {
            var slug = rec.name.toString().toLowerCase().replace(/\s+/g, '-');
            tags = (defaultTags ? defaultTags + ',' : '') + 'cyberdress-recommended-' + slug;
          }
          tagsInput.value = tags;
        }
        if (noteInput) {
          noteInput.value = rec
            ? 'CyberDress 2026 · recomendación ' + rec.name + ' · ' + rec.price + ' · recibes ' + rec.receive
            : 'CyberDress 2026 · suscripción desde exit modal (sin quiz)';
        }

        var successText = rec
          ? '✓ Listo. Te enviamos el link a tu ' + rec.name + ' al email.'
          : '✓ Listo. Te enviamos tu selección al email.';

        // Submit to Shopify's customer endpoint. The {% form 'customer' %}
        // tag emits action="/contact#contact_form" and includes the auth
        // hidden fields automatically, so a FormData fetch is enough.
        // Shopify returns 200 with HTML even on validation errors, so we
        // check status only — server-side validation (e.g. invalid email)
        // is also caught client-side by `required type="email"`.
        var fd = new FormData(form);
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Guardando…';
        }
        fetch(form.action, {
          method: form.method || 'POST',
          body: fd,
          headers: { 'Accept': 'text/html' },
          credentials: 'same-origin'
        }).then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          form.innerHTML = '<div class="cyberdress-exit-modal__success">' + escapeHtml(successText) + '</div>';
          window.setTimeout(close, 2800);
        }).catch(function (err) {
          if (window.console) console.warn('[CyberDress] exit-modal submit failed', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Reintentar →';
          }
        });
      });
    }
  }

  // ---------- 7. LIVE TOAST ----------
  function initLiveToast() {
    var toast = document.querySelector('[data-cyberdress-live-toast]');
    if (!toast) return;
    var nameEl = toast.querySelector('[data-cyberdress-toast-name]');
    var editionEl = toast.querySelector('[data-cyberdress-toast-edition]');
    var timeEl = toast.querySelector('[data-cyberdress-toast-time]');

    var names = parseCsvAttr(toast.getAttribute('data-names'),
      ['María Paz', 'Antonia', 'Catalina', 'Isidora', 'Florencia', 'Sofía', 'Camila', 'Magdalena', 'Trinidad', 'Josefa']);
    var times = parseCsvAttr(toast.getAttribute('data-times'),
      ['hace 2 min', 'hace 5 min', 'hace 8 min', 'hace 12 min', 'hace 18 min']);
    var editions = readEditions().map(function (e) { return e.name; });
    if (!editions.length) editions = ['Essential', 'Classic', 'Premium', 'Signature', 'Year Pass'];

    function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
    function show() {
      if (nameEl) nameEl.textContent = pick(names);
      if (editionEl) editionEl.textContent = pick(editions);
      if (timeEl) timeEl.textContent = pick(times);
      toast.classList.add('cyberdress-live-toast--visible');
      window.setTimeout(function () { toast.classList.remove('cyberdress-live-toast--visible'); }, 5000);
    }
    window.setTimeout(show, 12000);
    window.setInterval(show, 30000 + Math.random() * 15000);
  }

  // ---------- 8. STICKY BAR ----------
  function initStickyBar() {
    var bar = document.querySelector('[data-cyberdress-sticky-bar]');
    var finale = document.querySelector('[data-cyberdress-finale]');
    if (!bar) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y > 600) {
          if (finale) {
            var finaleTop = finale.getBoundingClientRect().top;
            if (finaleTop < window.innerHeight) {
              bar.classList.remove('cyberdress-sticky-bar--visible');
              ticking = false;
              return;
            }
          }
          bar.classList.add('cyberdress-sticky-bar--visible');
        } else {
          bar.classList.remove('cyberdress-sticky-bar--visible');
        }
        ticking = false;
      });
    }, { passive: true });
  }

  // ---------- Helpers ----------
  function readEditions() {
    var data = document.querySelector('[data-cyberdress-editions-data]');
    if (!data) return [];
    try {
      return JSON.parse(data.textContent || '[]');
    } catch (e) {
      if (window.console) console.warn('[CyberDress] could not parse editions data', e);
      return [];
    }
  }

  function parseCsvAttr(raw, fallback) {
    if (!raw) return fallback;
    var arr = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    return arr.length ? arr : fallback;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // ---------- Boot ----------
  ready(function () {
    if (!document.querySelector('[data-cyberdress-root]') && !document.querySelector('[data-cyberdress-exit-modal]')) {
      return;
    }
    initEditionStrip();
    initCountdown();
    initLookbook();
    initQuiz();
    initByYear();
    initExitModal();
    initLiveToast();
    initStickyBar();
  });
})();
